<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-04 15:29:50
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-04 15:31:40
 * @FilePath: /chaoyongtuan/src/views/settings/tagManage/components/search.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="yx-form-wrap">
		<el-form :inline="true" :model="formData" label-width="96px">
			<el-form-item label="标签名称">
				<el-input v-model="formData['tagName']" placeholder="请输入标签名称"></el-input>
			</el-form-item>
			<el-form-item style="margin-left: 24px">
				<el-button type="primary" @click="onSubmit">搜索</el-button>
				<el-button @click="onClear">清空</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';

export default {
	name: 'search',
	data() {
		return {
			formData: {},
		};
	},
	methods: {
		onClear() {
			this.formData = {};
			this.onSubmit();
		},
		onSubmit: throttle(function() {
			this.$emit('onSubmit', this.formData);
		}, 1000),
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-form-item--small.el-form-item {
	margin-bottom: 0px;
}
</style>
